import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Chips } from "@website/ui/chips";
import { Tooltip } from "@website/ui/tooltip";
import { numberConvert } from "@website/utils/number-convert";
import { useNearBy } from "./reserve-nearby.hook";
import { NearbyLocationsPropertiesTypes, ReservePropertiesTypes } from "./reserve-nearby.types";
export const ReserveNearBy = properties => {
  const $ = _c(14);
  const {
    places,
    distances,
    roadTypes,
    firstData,
    remainingData,
    roadAccessType,
    clickShowMore,
    showMore,
    roadAccessDescription
  } = useNearBy(properties);
  let t0;
  if ($[0] !== roadAccessDescription || $[1] !== roadAccessType || $[2] !== roadTypes) {
    t0 = roadAccessType && roadTypes[roadAccessType as keyof typeof roadTypes] && <div className="text-body-2 md:text-body-1 flex items-center gap-1 pb-6"><MaterialIcon name="info" variant="outlined" className="max-md:hidden" /><div className="flex flex-col pr-1">{roadTypes[roadAccessType as keyof typeof roadTypes] && <div className="text-on-surface-high-emphasis">دسترسی به اقامتگاه از جاده یا خیابان اصلی:{" "}<span className="font-extrabold">{roadTypes[roadAccessType as keyof typeof roadTypes]}</span></div>}{roadAccessDescription && <div className="text-on-surface-medium-emphasis">{roadAccessDescription}</div>}</div></div>;
    $[0] = roadAccessDescription;
    $[1] = roadAccessType;
    $[2] = roadTypes;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== clickShowMore || $[5] !== distances || $[6] !== firstData || $[7] !== places || $[8] !== remainingData || $[9] !== showMore) {
    t1 = Array.isArray(firstData) && <div className="flex flex-col"><h2 className="text-subtitle-1 md:text-headline-6 pb-1 md:pb-4">مراکز نزدیک اقامتگاه{" "}</h2><div className="grid md:grid-cols-2">{((showMore ? [...(firstData || []), ...(remainingData || [])] : firstData) as Array<NearbyLocationsPropertiesTypes>)?.map((item, index) => <div className={`border-outline-thin text-extra-caption text-on-surface-high-emphasis flex max-md:flex-col max-md:gap-2 ${index % 2 ? "" : "md:ml-6"} mt-2 flex items-center justify-between rounded-lg border p-2`} key={`${item?.locType}-${item?.distanceByCar ?? ""}-${item?.distanceByWalk ?? ""}`}><div className="max-md:!w-full">{places[item?.locType as keyof typeof places]}</div><div className="flex gap-2 max-md:!w-full">{item.distanceByCar && <Tooltip title={`رانندگی تا ${places[item?.locType as keyof typeof places]}  ${numberConvert(distances[item.distanceByCar as keyof typeof distances], {
              locale: "fa"
            })}`}><Chips StartIcon={<MaterialIcon name="directions_car" variant="outlined" />} color="primary" text={numberConvert(distances[item.distanceByCar as keyof typeof distances], {
                locale: "fa"
              }) as string} variant="contained" className="!w-36 !rounded-[4px]" /></Tooltip>}{item.distanceByWalk && <Tooltip title={`پیاده روی تا ${places[item?.locType as keyof typeof places]}  ${numberConvert(distances[item.distanceByWalk as keyof typeof distances], {
              locale: "fa"
            })}`}><Chips StartIcon={<MaterialIcon name="directions_walk" />} color="primary" text={numberConvert(distances[item.distanceByWalk as keyof typeof distances], {
                locale: "fa"
              }) as string} variant="contained" className="!w-36 !rounded-[4px]" /></Tooltip>}</div></div>)}</div>{!showMore && <div onClick={clickShowMore} className="text-button text-on-surface-high-emphasis border-on-surface-high-emphasis mt-4 w-full cursor-pointer rounded-lg border py-2 text-center">مشاهده مکان های بیشتر</div>}</div>;
    $[4] = clickShowMore;
    $[5] = distances;
    $[6] = firstData;
    $[7] = places;
    $[8] = remainingData;
    $[9] = showMore;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== t0 || $[12] !== t1) {
    t2 = <div className="py-6">{t0}{t1}</div>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};